module.exports = __webpack_public_path__ + "static/media/offlineTasks.158ffa0b.svg";